import * as React from 'react';
import { Trans } from '@lingui/macro';
import { useAccountOrdersArDocFileNameExtension } from '../../hooks';

export const AccountOrdersArDocDocumentType = () => {
  const {
    data,
  } = useAccountOrdersArDocFileNameExtension();
  return (
    <Trans>
      Document&#32;
      {data}
    </Trans>
  );
};
